import React, { useEffect, useState } from 'react';
import {Button, Heading, Stack, Text} from "@chakra-ui/react";
import Cookies from "js-cookie";
import { useAnvilProps } from "frontend/hooks";
import {analytics, anvilAnalyticsConfig} from "../../../analytics/static_src/anvil-analytics/analytics";

/**
 * The Order Tunnel screen that authenticated users will be redirected to if they have an existing active subscription.
 * @returns {JSX.Element}
 * @constructor
 */
export default function AlreadySubscribedScreen() {
    const {cookies} = useAnvilProps();

    const [redirectUrl, setRedirectUrl] = useState('/');

    useEffect(() => {
        analytics.page(anvilAnalyticsConfig.page_payload);
    }, [])

    useEffect(() => {
        // Grab the saved redirect url from the cookies before deleting them
        if (cookies && cookies.order_tunnel_finished_redirect_url) {
            const cookieRedirectUrl = Cookies.get(cookies.order_tunnel_finished_redirect_url);
            if (cookieRedirectUrl) {
                setRedirectUrl(cookieRedirectUrl);
            }
        }

        // Delete the cookies that get set to handle social logins
        Object.entries(cookies).forEach(([, cookie_key]) => Cookies.remove(cookie_key));
    }, [cookies]);

    return (
        <Stack spacing={4}>
            <Heading size={"lg"}>Thank you for being a valued subscriber!</Heading>
            <Text>It looks like you already have a subscription. To renew and keep enjoying our services, please call our customer service team by visiting our contact us page. We’re excited to help you continue your journey with us!</Text>
            <Button
                as="a"
                colorScheme="blue"
                width="max-content"
                href={redirectUrl}
                sx={{"&:hover,&:focus": {color: "white"}}}
            >Go back</Button>
        </Stack>
    );
}
